module.exports = __webpack_public_path__ + "static/makeYourMemory-edea414533c4326e7c298fab15590740.png";